
      var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBank = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.31 9.273H3.6a.873.873 0 0 0-.873.872V20.4c0 .482.39.873.872.873h16.8c.482 0 .873-.391.873-.873V10.145a.873.873 0 0 0-.873-.872h-2.71",
  stroke: "#000",
  strokeWidth: 1.6
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.31 9.273H3.6a.873.873 0 0 0-.873.872v.982c0 .482.39.873.872.873h17.673v-1.855a.873.873 0 0 0-.873-.872h-2.71",
  stroke: "#000",
  strokeWidth: 1.6
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 2.727a6 6 0 0 1 5.434 8.545h-1.845a4.4 4.4 0 1 0-7.178 0H6.566A6 6 0 0 1 12 2.727Z",
  fill: "#000"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.228 10.47c2.699 0 3.273-1.363 3.379-3.454l.03-.512a.4.4 0 0 0-.398-.425h-.659a.4.4 0 0 0-.4.39l-.01.371c-.066 1.706-.19 2.51-1.77 2.51-.06 0-.2-.013-.335-.026a.395.395 0 0 1-.355-.359l-.062-.69a.4.4 0 0 0-.398-.364h-.447a.4.4 0 0 0-.398.44l.171 1.712c.02.196.18.348.376.358.385.02.993.049 1.276.049Z",
  fill: "#000"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.494 10.003c0 .221.18.4.4.4h.56a.4.4 0 0 0 .4-.4V7.658c0-.22.178-.4.4-.4h1.408c.335 0 .498.117.498.419v.545c0 .22.18.4.4.4h.511a.4.4 0 0 0 .4-.4v-.545c0-1.255-.517-1.598-1.809-1.598H8.894a.4.4 0 0 0-.4.4v3.524Z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M6.30921 9.27271H3.59929C3.1173 9.27271 2.72656 9.66344 2.72656 10.1454V20.4C2.72656 20.882 3.11729 21.2727 3.59929 21.2727H20.3993C20.8813 21.2727 21.272 20.882 21.272 20.4V10.1454C21.272 9.66344 20.8813 9.27271 20.3993 9.27271H17.6894\" stroke=\"black\" stroke-width=\"1.6\"/>\r\n<path d=\"M6.30921 9.27271H3.59929C3.1173 9.27271 2.72656 9.66344 2.72656 10.1454V11.1273C2.72656 11.6092 3.11729 12 3.59929 12H21.272V10.1454C21.272 9.66344 20.8813 9.27271 20.3993 9.27271H17.6894\" stroke=\"black\" stroke-width=\"1.6\"/>\r\n<path d=\"M12 2.72729C15.3137 2.72729 18 5.41359 18 8.72729C18 9.63733 17.7962 10.4995 17.4336 11.2722H15.5889C16.0994 10.5536 16.4004 9.67578 16.4004 8.72729C16.4004 6.29724 14.4301 4.3269 12 4.3269C9.56995 4.3269 7.59961 6.29724 7.59961 8.72729C7.59961 9.67578 7.90062 10.5536 8.41113 11.2722H6.56641C6.20385 10.4995 6 9.63733 6 8.72729C6 5.41359 8.68629 2.72729 12 2.72729Z\" fill=\"black\"/>\r\n<path d=\"M12.2278 10.47C14.9269 10.47 15.5012 9.10674 15.6065 7.01583L15.6379 6.50358C15.652 6.27347 15.4692 6.0791 15.2387 6.0791H14.58C14.363 6.0791 14.1856 6.25212 14.1801 6.46904L14.1708 6.84019C14.1038 8.54637 13.9794 9.34928 12.4001 9.34928C12.3398 9.34928 12.2001 9.33744 12.0647 9.32441C11.8754 9.30619 11.7274 9.15464 11.7103 8.96523L11.648 8.27482C11.6294 8.06866 11.4566 7.91074 11.2496 7.91074H10.8033C10.5666 7.91074 10.3817 8.11503 10.4052 8.35048L10.5762 10.0627C10.5958 10.2587 10.7551 10.4112 10.9518 10.4214C11.3366 10.4412 11.9451 10.47 12.2278 10.47Z\" fill=\"black\"/>\r\n<path d=\"M8.49414 10.0031C8.49414 10.224 8.67323 10.4031 8.89414 10.4031H9.4533C9.67421 10.4031 9.8533 10.224 9.8533 10.0031V7.65837C9.8533 7.43746 10.0324 7.25837 10.2533 7.25837H11.6623C11.9973 7.25837 12.16 7.37547 12.16 7.67656V8.22165C12.16 8.44256 12.3391 8.62165 12.56 8.62165H13.0713C13.2922 8.62165 13.4713 8.44256 13.4713 8.22165V7.67656C13.4713 6.42201 12.9545 6.0791 11.6623 6.0791H8.89414C8.67323 6.0791 8.49414 6.25819 8.49414 6.4791V10.0031Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/bank.19bce3897c844d3aa573209309ade6ec.svg"),
        {
          React: SvgBank,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      